<template>
   <!-- 项目 - 预警设置 -->
   <div class="main-box">
       <div class="head-box">
          <el-button type="primary" @click="addConfig">新增</el-button>
       </div>
       <div class="table-box">
           <el-table
                stripe
                :data="listData"
                height="100%"
                style="width: 100%;"
                :header-cell-style="{background:'#fff',color:'#909399'}"
              >
                <template slot="empty">
                  <p>{{dataText}}</p>
                </template>
                <!-- <el-table-column label="序号" width="100">
                  <template slot-scope="scope">
                    <a>{{ scope.row.index}}</a>
                  </template>
                </el-table-column> -->
                <el-table-column label="事件类型">
                  <template slot-scope="scope">
                    <router-link :to="'/setWarnInfo/'+scope.row.type+'/0'">{{ scope.row.name }}</router-link>
                    <!-- <span>{{ scope.row.name }}</span> -->
                  </template>
                </el-table-column>
                <el-table-column label="监测范围">
                  <template slot-scope="scope">
                    <span>{{ scope.row.channelName }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="预警时间段">
                  <template slot-scope="scope">
                    <p v-for="(item,i) in scope.row.timeName" :key="i">
                      <span>{{ item.start }}</span>
                      ~
                      <span>{{ item.end }}</span>
                    </p>
                  </template>
                </el-table-column>
                <el-table-column label="预警持续时间">
                  <template slot-scope="scope">
                    <span>{{ scope.row.warningDuration }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="操作">
                <template slot-scope="scope">
                  <el-button type="text" @click="exportFun(scope.row)" size="mini">配置</el-button>
                </template>
              </el-table-column>
          </el-table>
       </div>
   </div>
</template>

<script>
import myHttp from '../../../untils/port'
import util from '../../../untils/util'
export default {
    data(){
        return{
            listData:[],
            groupId:'',
            dataText:'数据加载中...',
        }
    },
    mounted(){
      this.groupId = util.session.get('groupId')
      this.getData()
    },
    methods:{

        //获取数据
        getData(){
          var that = this
          myHttp.selectProjectConfigCameraList({
            projectId:this.groupId
          }).then(function(resp){
            if(resp.data.code=='200'){
              var list = resp.data.data.configs||[]
              for(var i=0;i<list.length;i++){
                var li = list[i].time&&''!=list[i].time?JSON.parse(list[i].time):[]
                list[i].timeName = li
                // for(var j=0;j<li.length;j++){
                //   list[i].timeName += li[j].start+' ~ '+li[j].end+'\n'
                // }
              }
              that.listData = list
              if(list.length==0){
                that.dataText = '暂无数据'
              }
            }else{
              that.dataText = '暂无数据'
            }
          })
        },
        //配置
        exportFun(row){
            this.$router.push({path:'setWarnInfo/'+row.type+'/1'})
        },
        //新增
        addConfig(){
          this.$router.push({path:'setWarnInfo/0/1'})
        },
    }
}
</script>
<style scoped>
  .main-box{
      width: 100%;
      height: 100%;
      position: relative;
      background: #fff;
  }
  .head-box{
      width: 100%;
      height: 7vh;
      position: relative;
      /* background: #f2f2f2; */
      display: flex;
      align-content: center;
      align-items: center;
      padding-right: 5vw;
      justify-content: flex-end;
  }
  .table-box{
      width: 100%;
      height: calc( 100% - 5vh );
      position: relative;
      padding: 1vh 2vh;
  }
</style>
<style>
    @import '../../../assets/css/common.css'
</style>